import { connect } from 'react-redux';
import WHYGOSOLAR from './WHYGOSOLAR';
import { getAnnualResults } from '../../selectors';


import { setHorizonLengthChange, setYearSliderChange } from '../../../../../common/settings/actions';


const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    horizonLength: state.settings.horizonLength,
    resiToggle: state.tax.resiToggle,
    taxRate: state.tax.taxRate,
    provider: state.utility.provider,
    projectState: state.projectaddress.projectState,
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
    cashprice: state.solar.cashprice,
    essToggle: state.ess.essToggle,
    essPrice: state.ess.essPrice,
    smartValue: state.smart.smartValue,
    installYear: state.tax.installYear,
    loanProvider: state.loan.loanProvider,
    showLoan: state.loan.showLoan,
    mosaicFee: state.loan.mosaicFee,
    selectedFinancing: state.settings.selectedFinancing,
    setHorizonLengthChange,
    setYearSliderChange,
});

const combinedActions = {
    setHorizonLengthChange,
    setYearSliderChange,
};

export default connect(mapStateToProps, combinedActions)(WHYGOSOLAR);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/WHYGOSOLAR/index.js